import CloseIcon from "@mui/icons-material/Close";
import ContentCopyOutlined from "@mui/icons-material/ContentCopyOutlined";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";

interface EmbedCodeDialogProps {
  open: boolean;
  onClose: () => void;
  agent: any;
  embedCode: string;
  onCopyCode: () => void;
}

const EmbedCodeDialog: React.FC<EmbedCodeDialogProps> = ({
  open,
  onClose,
  agent,
  embedCode,
  onCopyCode,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        Website Embed Code
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          Add this code to your website to enable the agent. Place it anywhere
          in your HTML, preferably in the &lt;head&gt; section or just before
          the closing &lt;/body&gt; tag.
        </DialogContentText>

        {agent && (
          <Box>
            <Box sx={{ mb: 2, p: 2, borderRadius: 1 }}>
              <Typography variant="subtitle2" sx={{ mb: 1 }}>
                Agent: {agent.name}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Position:{" "}
                {agent.channelSettings?.website?.position ||
                  agent.placementSettings?.position ||
                  "bottom-right"}
              </Typography>
            </Box>

            <TextField
              multiline
              rows={8}
              fullWidth
              value={embedCode}
              InputProps={{
                readOnly: true,
                sx: {
                  fontFamily: "monospace",
                  fontSize: "14px",
                  "& .MuiInputBase-input": {
                    fontFamily: "monospace",
                  },
                },
              }}
              variant="outlined"
            />
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
        <Button
          variant="contained"
          startIcon={<ContentCopyOutlined />}
          onClick={onCopyCode}
        >
          Copy Code
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EmbedCodeDialog;
